var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoConstructora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_468",
    "data-name": "Group 468",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 390.805,
    height: 87.823,
    viewBox: "0 0 390.805 87.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #003961;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    className: "cls-1",
    width: 390.805,
    height: 87.823
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    className: "cls-3",
    d: "M120.4,84.333H109.281a7.559,7.559,0,0,1-4.07-1.514L72.024,54.044V49.877H99.793a4.724,4.724,0,0,0,4.719-4.717V24.27l15.1,7.636a1.689,1.689,0,0,0,.79.2,1.754,1.754,0,0,0,.791-3.311L65.725.747A8.367,8.367,0,0,0,58.849.731L.966,29.579a1.743,1.743,0,0,0-.783,2.335,1.74,1.74,0,0,0,1.565.976,1.7,1.7,0,0,0,.77-.193l17.2-8.57V83.114A1.221,1.221,0,0,1,18.5,84.333H1.748a1.745,1.745,0,1,0,0,3.49H18.5a4.719,4.719,0,0,0,4.719-4.708V22.385L60.411,3.85a4.289,4.289,0,0,1,1.851-.359,4.359,4.359,0,0,1,1.879.368l36.887,18.657V45.159a1.225,1.225,0,0,1-1.235,1.224H70.287a1.75,1.75,0,0,0-1.747,1.749v6.709a1.733,1.733,0,0,0,.6,1.317l33.792,29.295a10.881,10.881,0,0,0,6.352,2.37H120.4a1.745,1.745,0,0,0,0-3.49",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    className: "cls-3",
    d: "M288.29,122.444h6.855V149.7h15.077v6.023H288.29Z",
    transform: "translate(-161.27 -68.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    className: "cls-3",
    d: "M359.7,121.764h.586l15.223,33.579h-7.2l-1.561-3.768H353.237l-1.563,3.768h-6.61Zm4.605,24.082-2.405-5.774c-.977-2.352-2-5.969-2-5.969a60.543,60.543,0,0,1-1.953,5.969l-2.4,5.774Z",
    transform: "translate(-193.03 -68.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    className: "cls-3",
    d: "M471.18,155.723h-7.933l-5.477-8.417a13.473,13.473,0,0,1-1.965.144h-2.353v8.274h-6.845V122.444h9.2c9.3,0,14.883,4.449,14.883,12.574,0,5.184-2.3,8.469-6.413,10.329Zm-15.57-14.24c5.581,0,8.025-1.762,8.025-6.465s-2.548-6.557-8.025-6.557h-2.159v13.022Z",
    transform: "translate(-249.833 -68.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    className: "cls-3",
    d: "M523.337,121.764h.587l15.23,33.579H531.96l-1.572-3.768H516.872l-1.562,3.768H508.7Zm4.6,24.082-2.406-5.774c-.976-2.352-2-5.969-2-5.969a60.756,60.756,0,0,1-1.952,5.969l-2.407,5.774Z",
    transform: "translate(-284.569 -68.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    className: "cls-3",
    d: "M588.032,121.649h.536l16.392,18.012,16.157-18.012h.586v33.629h-6.609V142.8c0-2.251.247-5.828.247-5.828s-2,2.94-3.567,4.708l-6.608,7.389h-.639l-6.606-7.389a58.394,58.394,0,0,1-3.577-4.708s.235,3.577.235,5.828v12.483h-6.547Z",
    transform: "translate(-328.947 -68.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    className: "cls-3",
    d: "M689.317,121.764h.574l15.233,33.579h-7.2l-1.562-3.768h-13.5l-1.571,3.768h-6.61Zm4.594,24.082-2.4-5.774c-.987-2.352-2.017-5.969-2.017-5.969a60.483,60.483,0,0,1-1.95,5.969l-2.4,5.774Z",
    transform: "translate(-377.413 -68.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    className: "cls-3",
    d: "M754,122.444H764.23c10.236,0,17.522,6.8,17.522,16.632s-7.245,16.647-17.522,16.647H754ZM763.89,149.7c7.389,0,10.771-4.405,10.771-10.624s-3.382-10.615-10.771-10.615h-3.033V149.7Z",
    transform: "translate(-421.791 -68.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    className: "cls-3",
    d: "M832.506,121.764h.585l15.234,33.579h-7.2l-1.569-3.768H826.042l-1.564,3.768h-6.607Zm4.6,24.082-2.394-5.774c-.987-2.352-2.014-5.969-2.014-5.969a60.68,60.68,0,0,1-1.953,5.969l-2.4,5.774Z",
    transform: "translate(-457.519 -68.115)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConstructora);
export default __webpack_public_path__ + "static/media/logo-constructora.f4820ef52c27fedbf5cac06cb0f33679.svg";
export { ForwardRef as ReactComponent };